export const courseBase = {
  title: '',
};

export const ENU_COURSE_AD_SWITCH = {
  NONE: 0,
  WHITE_LIST: 1,
  BLANK_LIST: 2,
};
